import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PatientService } from '../services/patient.service';
import { Observable } from 'rxjs/Observable';
import { Patient } from '../models/patient';
import { LoadingIndicatorService } from '../services/loading-indicator.service';

@Component({
  selector: 'qmed-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [PatientService]
})
export class FullLayoutComponent implements OnInit {
  patients: Observable<Patient[]>;
  loading: boolean;
  constructor(public patientService: PatientService, private loadingService: LoadingIndicatorService) {}

  ngOnInit() {
    this.loading = this.loadingService.isloading();
  }
}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/full-layout/full-layout.component.ts